/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiScenarioVersionStatus } from './InternalApiScenarioVersionStatus';
import {
    InternalApiScenarioVersionStatusFromJSON,
    InternalApiScenarioVersionStatusFromJSONTyped,
    InternalApiScenarioVersionStatusToJSON,
    InternalApiScenarioVersionStatusToJSONTyped,
} from './InternalApiScenarioVersionStatus';

/**
 * 
 * @export
 * @interface InternalApiRiskRuleVersion
 */
export interface InternalApiRiskRuleVersion {
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersion
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRiskRuleVersion
     */
    versionId: number;
    /**
     * 
     * @type {InternalApiScenarioVersionStatus}
     * @memberof InternalApiRiskRuleVersion
     */
    status: InternalApiScenarioVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersion
     */
    note?: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiRiskRuleVersion
     */
    updatedBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRiskRuleVersion
     */
    updatedTime: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersion
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleVersion
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRiskRuleVersion
     */
    weight: number;
}



/**
 * Check if a given object implements the InternalApiRiskRuleVersion interface.
 */
export function instanceOfInternalApiRiskRuleVersion(value: object): value is InternalApiRiskRuleVersion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    return true;
}

export function InternalApiRiskRuleVersionFromJSON(json: any): InternalApiRiskRuleVersion {
    return InternalApiRiskRuleVersionFromJSONTyped(json, false);
}

export function InternalApiRiskRuleVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRiskRuleVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'versionId': json['versionId'],
        'status': InternalApiScenarioVersionStatusFromJSON(json['status']),
        'note': json['note'] == null ? undefined : json['note'],
        'updatedBy': InternalApiUserBasicDetailsFromJSON(json['updatedBy']),
        'updatedTime': (new Date(json['updatedTime'])),
        'details': json['details'],
        'content': json['content'],
        'weight': json['weight'],
    };
}

export function InternalApiRiskRuleVersionToJSON(json: any): InternalApiRiskRuleVersion {
    return InternalApiRiskRuleVersionToJSONTyped(json, false);
}

export function InternalApiRiskRuleVersionToJSONTyped(value?: InternalApiRiskRuleVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'versionId': value['versionId'],
        'status': InternalApiScenarioVersionStatusToJSON(value['status']),
        'note': value['note'],
        'updatedBy': InternalApiUserBasicDetailsToJSON(value['updatedBy']),
        'updatedTime': value['updatedTime'].toISOString(),
        'details': value['details'],
        'content': value['content'],
        'weight': value['weight'],
    };
}

